import { createSelector } from "reselect";

export const customerSelector = ({ customer }) => customer;
export const customerBillingAddress = createSelector(
  customerSelector,
  (customer) => ({
    firstname: customer.firstname,
    lastname: customer.lastname,
    street: customer.address[0].street,
    street2: customer.address[0].street2 ?? "",
    city: customer.address[0].city,
    state: customer.address[0].state,
    postcode: customer.address[0].postcode,
  })
);
